import React from 'react';
import DiscoverHeader from './discover/DiscoverHeader';
import DiscoverPage from './discover/DiscoverPage';

function Discover() {
  return (
    <div className="Discover">
      <DiscoverHeader />
      <DiscoverPage />
    </div>
  );
}

export default Discover;
